export interface IBeneficiaryDetails {
  beneficiaryId: string;
  firstName: string;
  fullName: string;
  middleName: string;
  lastName: string;
  familyName: string;
  dob: Date;
  gender: string;
  bloodGroupNameEnglish: string;
  bloodGroupNameArabic: string;
  nationalityNameEnglish: string;
  nationalityNameArabic: string;
  maritalStatusId: string;
  maritalStatusNameArabic: string;
  maritalStatusNameEnglish: string;
  residencyTypeId: string;
  residencyTypeNameArabic: string;
  residencyTypeNameEnglish: string;
  preferredLanguageId: string;
  languageNameEnglish: string;
  languageNameArabic: string;
  memberId: string;
  beneficiaryDocuments: IBeneficiaryDocument[];
  patientFileNo: string;
  passportNumber: string;
  visaNumber: string;
  borderNumber: string;
  visaTypeNameEnglish: string;
  visaTypeNameArabic: string;
  visitTitle: string;
  visaExpiryDate: Date;
  address: IAddressDetails;
  contact: IContact;
  erpBeneficiaryId?: string;
}

interface IAddressDetails {
  street: string;
  cityNameEnglish: string;
  cityNameArabic: string;
  stateNameEnglish: string;
  stateNameArabic: string;
  countryNameEnglish: string;
  countryNameArabic: string;
  zipcode: string;
  latitude: string;
  longitude: string;
}

export interface IBeneficiaryList {
  beneficiaryId: string;
  fullName: string;
  dob: string;
  gender: string;
  nationalityNameEnglish: string;
  nationalityNameArabic: string;
  nationalityId: string;
  address: {
    cityId: string;
  };
  beneficiaryDocuments: IBeneficiaryDocument[];
  memberId: string;
  erpBeneficiaryId?: string;
}

export interface IBeneficiary {
  beneficiaryId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName?: string;
  familyName: string;
  dob: Date;
  gender: string;
  bloodGroupId: string;
  nationalityId: string;
  maritalStatusId: string;
  residencyTypeId: string;
  preferredLanguageId: string;
  memberId: string;
  beneficiaryDocuments: IBeneficiaryDocument[];
  patientFileNo: string;
  passportNumber: string;
  visaNumber: string;
  borderNumber: string;
  visaTypeId: string;
  visaTitle: string;
  visaExpiryDate: Date;
  address: IAddress;
  contact: IContact;
  maritalStatusNameEnglish?: string
  maritalStatusNameArabic?: string;
  createdDate?: string;
}

export interface IBeneficiaryDocument {
  beneficiaryDocumentsId: string | null;
  beneficiaryId: string;
  documentTypeId: string;
  documentTypeNameEnglish: string;
  documentTypeNameArabic: string;
  documentId: string;
}

interface IContact {
  email: string;
  contactNumber: string;
  emergencyNumber: string;
  mobileNumber: string;
}

interface IAddress {
  street: string;
  cityId: string;
  stateId: string;
  countryId: string;
  zipcode: string;
  latitude: string;
  longitude: string;
}

export const beneficiaryConfig = {
  entityName: 'BENEFICIARY.TITLE',
  firstName: 'FORM_FIELD.FIRST_NAME',
  middleName: 'FORM_FIELD.MIDDLE_NAME',
  lastName: 'FORM_FIELD.LAST_NAME',
  familyName: 'FORM_FIELD.FAMILY_NAME',
  email: 'FORM_FIELD.EMAIL',
  contactNumber: 'FORM_FIELD.CONTACT_NUMBER',
  emergencyNumber: 'FORM_FIELD.EMERGENCY_NUMBER',
  documentId: 'FORM_FIELD.DOCUMENT_ID',
  document: 'FORM_FIELD.DOCUMENT',
  street: 'FORM_FIELD.STREET',
  zipcode: 'FORM_FIELD.ZIPCODE',
  latitude: 'FORM_FIELD.LATITUDE',
  longitude: 'FORM_FIELD.LONGITUDE',
  patientFileNo: 'FORM_FIELD.PATIENT_NUMBER',
  passportNumber: 'FORM_FIELD.PASSPORT_NUMBER',
  visaNumber: 'FORM_FIELD.VISA_NUMBER',
  borderNumber: 'FORM_FIELD.BORDER_NUMBER',
  visaTitle: 'COMMON.VISA_TITLE',
  memberId: 'FORM_FIELD.MEMBER_ID',
  mobileNumber: 'FORM_FIELD.MOBILE_NO',
  bloodGroupId: 'CONFIGURATION.MASTER_DATA.BLOOD_GROUP.TITLE',
  gender: 'FORM_FIELD.GENDER',
  isNewborn: 'FORM_FIELD.IS_NEW_BORN',
  nationalityId: 'FORM_FIELD.NATIONALITY',
  maritalStatusId: 'FORM_FIELD.MARITAL_STATUS',
  residencyTypeId: 'FORM_FIELD.RESIDENT_TYPE',
  preferredLanguageId: 'FORM_FIELD.PREFERRED_LANGUAGE',
  documentTypeId: 'CONFIGURATION.MASTER_DATA.DOCUMENT_TYPE.TITLE',
  visaTypeId: 'CONFIGURATION.MASTER_DATA.VISA_TYPE.TITLE',
  borderNoValidation: "FORM_FIELD.BORDER_NO_VALIDATION",
  passportNoValidation: "FORM_FIELD.PASSPORT_NO_VALIDATION",
};